import React from 'react';
import Container from 'react-bootstrap/Container';
import "./investorforum.scss";
import { Link } from 'react-router-dom';
import BackButton from '../Common/BackButton/BackButton';
import Logo from "../../assets/images/logo.svg";
import ComingSoonModal from '../Common/ComingSoon/ComingSoonModal';

const Investorforum = () => {
  const token = localStorage.getItem("access_token");
  const isLoggedIn = !!(token && token !== "undefined" && token !== "null" && token.trim() !== "");

  return (
    <>
      <section className={`investor-page ${!isLoggedIn ? 'guest-mode' : ''}`} style={{ minHeight: "80vh", paddingBottom: "60px" }}>
        <Container>
          {!isLoggedIn ? (
            <div
              className="guest-forum-header d-flex align-items-center justify-content-between flex-wrap py-3 px-4 px-md-5 mb-4 rounded-3"
              style={{
                background: "#ffffff",
                border: "1px solid #e8ece9",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
                minHeight: "80px",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <Link to="/" className="d-inline-flex align-items-center">
                  <img
                    src={Logo}
                    alt="The Prime Shark"
                    height={42}
                    style={{ objectFit: "contain" }}
                  />
                </Link>
                <div className="d-none d-md-block border-start border-secondary border-opacity-25 ps-3 ms-1">
                  <h2 className="fw-bold mb-0 fs-5" style={{ color: "#1e3a2b" }}>
                    Investor Forum
                  </h2>
                  <p className="mb-0 text-muted small">
                    Explore business insights, market trends & investment opportunities.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3 mt-3 mt-md-0">
                <Link
                  to="/login"
                  className="guest-header-btn-login"
                >
                  Log In
                </Link>
                <Link
                  to="/login"
                  className="guest-header-btn-join"
                >
                  Join Now
                </Link>
              </div>
            </div>
          ) : (
            <h4 className="mt-3 font-bold mb-4 d-flex align-items-center gap-2">
              <BackButton fallbackUrl="/" />
              <span>Investor Forum</span>
            </h4>
          )}

          {/* Full Page Coming Soon UI */}
          <ComingSoonModal isPage={true} title="Investor Forum" />
        </Container>
      </section>
    </>
  );
};

export default Investorforum;
